import{a as r}from"./chunk-RAAYCPUM.js";function m(...e){return r(i,e)}function i(e,t){for(let[n,o]of e.entries())if(!t(o,n,e))return e.slice(n);return[]}export{m as a};
